export default __webpack_public_path__ + "static/media/IMG7295.702c799a.jpg";